import { createAsyncThunk } from '@reduxjs/toolkit';

import { configVars } from 'src/helpers';
import { RootState } from 'src/store';
import { Status as StatusTypes } from 'src/ts/enums';
import api from './api';
import { NAME } from './constants';

export const getApplicationTrackingAccessThunk = createAsyncThunk(
  `${NAME}/getAccess`,
  async () => {
    try {
      return await api.getAccess(
        configVars.databricks.embedded_dashboards.application_tracking_dashboard_id
      );
    } catch (error) {
      console.error(`${NAME}/getAccess`, error);
      throw new Error('Error checking Application Tracking access');
    }
  },
  {
    condition: (_, { getState }) => (getState() as RootState)[NAME].status === StatusTypes.IDLE
  }
);
